export const ANNOUNCEMENT_PAGE_SIZE = 50;

export function announcementPageRange(page: number): { from: number; to: number } {
  const safePage = Number.isSafeInteger(page) && page >= 0 ? page : 0;
  const from = safePage * ANNOUNCEMENT_PAGE_SIZE;
  return { from, to: from + ANNOUNCEMENT_PAGE_SIZE - 1 };
}

export function announcementPageCount(total: number): number {
  return Math.max(1, Math.ceil(Math.max(0, total) / ANNOUNCEMENT_PAGE_SIZE));
}
